export function FireIconSmall({ color = '#E3262F' }: { color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_3630_4002)">
        <path
          d="M6.99999 13.4167C8.16032 13.4167 9.27312 12.9557 10.0936 12.1353C10.9141 11.3148 11.375 10.202 11.375 9.04167C11.375 8.5365 11.2408 8.05175 11.0833 7.60083C10.1109 8.56158 9.37241 9.04167 8.86666 9.04167C11.1971 4.95833 9.91666 3.20833 6.41666 0.875C6.70833 3.79167 4.78566 5.11817 4.00283 5.85492C3.36427 6.45556 2.92088 7.23419 2.73016 8.08986C2.53944 8.94552 2.61017 9.83875 2.9332 10.6537C3.25622 11.4687 3.81663 12.1678 4.54177 12.6605C5.26691 13.1531 6.12333 13.4166 6.99999 13.4167ZM7.41416 3.05375C9.30475 4.65792 9.31408 5.9045 7.85341 8.46358C7.40949 9.24117 7.97124 10.2083 8.86666 10.2083C9.26799 10.2083 9.674 10.0917 10.1027 9.86125C9.97566 10.3413 9.73886 10.7853 9.411 11.1583C9.08314 11.5313 8.67317 11.8231 8.21337 12.0108C7.75357 12.1984 7.25649 12.2767 6.76127 12.2396C6.26605 12.2024 5.78622 12.0508 5.35955 11.7967C4.93288 11.5426 4.57102 11.1929 4.30248 10.7752C4.03393 10.3574 3.86602 9.88305 3.81197 9.38939C3.75792 8.89573 3.81921 8.39626 3.99101 7.93032C4.1628 7.46437 4.44042 7.04467 4.80199 6.70425C4.87549 6.63542 5.24824 6.30467 5.26458 6.29008C5.51191 6.06842 5.71549 5.87183 5.91674 5.65658C6.63424 4.88775 7.14991 4.03492 7.41358 3.05375H7.41416Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3630_4002">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
